import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "../../Components/withRouter";
import { createSelector } from 'reselect';
import user1 from "assets/images/users/user.jpg";

import { useSelector } from "react-redux";

const selectProperties = createSelector(
  (state: any) => state.user,
  (user) => ({ user: user.user,  })
);

const ProfileMenu = (props: any) => {
  const [menu, setMenu] = useState(false);
  const { user } = useSelector(selectProperties);
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{user?.name || "User"}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to={'/profile'}>
            <DropdownItem >
              <i className="bx bx-user font-size-16 align-middle me-1" />
              Profile
            </DropdownItem>
          </Link>
          <Link to='/change-password'>
            <DropdownItem tag="a">
              <i className="bx bx-wrench font-size-16 align-middle me-1" />
              Change Password
            </DropdownItem>
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(ProfileMenu);